export default function (data, name, url) {
    window.history.pushState(
        data,
        name,
        url,
    );
}
